import React from "react";
import axios from "axios";
import Grid from '@mui/material/Grid';
import ActionAlert from "../Alert/ActionAlert.jsx";
import CardMarkerSmall from "./CardMarkerSmall.jsx";
import PgxAccordion from "../TextComps/PgxAccordion.jsx";
import ButtonGeneGrey from "../../components/Button/ButtonGeneGrey.jsx"
import ButtonGeneTrans from "../Button/ButtonGeneTrans.jsx";


export default function PgxCardTemplate(props) {

const {panel_url, panel_name, panel_subtext } = props

const url_panel = {panel_url}
const [variantInfo, setVariantInfo] = React.useState(null);
const [error, setError] = React.useState(null);

React.useEffect(() => {retrievePanel();}, []);

const retrievePanel = () => {
  axios
    .get(url_panel.panel_url)
    .then((res) => {
      setVariantInfo(res.data);

    })
    .catch(function (error) {
      if (error.response) {
        // Request made and server responded
        setError(error.response.data);
      } else if (error.request) {
        // The request was made but no response was received
        setError("The request was made but no response was received.");
      } else {
        // Something happened in setting up the request that triggered an Error
        setError("Error: " + error.message);
      }
    });
};

return(
<>

{variantInfo ? 

      <CardMarkerSmall

        headline = {panel_name} 
        subtext = {panel_subtext}
        cardlines = {<>

        {variantInfo.map((i, index) => 
              
              <PgxAccordion key={index} 

                  drugname = {i.drug}
                  source = {<ButtonGeneTrans  name={i.source} />}

                  g="PGx Gene:"
                  gt="Genotype:"
                  ph="Phenotype:"

                  genename={<ButtonGeneGrey  name={i.gene} />}
                  genotype={i.genotype}
                  phenotype={i.phenotype}

                  gl="Guideline:"
                  gl_name={i.guideline}
                  pop="Population:"
                  pop_name={i.population}

                  imp="Implications:"
                  imp_name={i.implications}
                  rec="Reommendation:"
                  rec_name={i.drugRecommendaiton}
                  clas="Classification:"
                  clas_name={i.classification}
                  
                  
                  alt="Alternate Drug Available?"
                  alt_name={i.alternateDrugAvailable}
                  url="URL:"
                  url_name={i.gl_url}

         />  
      )}  
      </>}

    />

 : 

    <Grid container mt={2} mb={2} justifyContent="center" rowspacing={2}>
        <Grid size={12}>
        <ActionAlert
            severity="warning"
            message={"Currently no information available"}
        />
        </Grid>
    </Grid>

}

{error && (
          <Grid container mt={2} mb={1} justifyContent="center" rowspacing={1}>
            <Grid size={12}>
              <ActionAlert severity="error" message={error.message} />
            </Grid>
          </Grid>
)}

</> 
)
}

